var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":_vm.maxWidth,"persistent":_vm.persistent},model:{value:(_vm.internalDialog),callback:function ($$v) {_vm.internalDialog=$$v},expression:"internalDialog"}},[_c('v-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }